// @flow

import { bindActionCreators } from 'redux';
import type { Dispatch } from 'redux';
import { connect } from 'react-redux';

import * as Selectors from '../selectors';
import * as AuthActions from '../actions/auth';
import * as ChatThreadActions from '../actions/chatThreads';
import * as ReportActions from '../actions/reports';
import Sidebar from '../components/sidebar';
import { SHOW_HEADCOUNT_PLANNER } from '../constants/features';
import { CAN_VIEW_SETTINGS_PAGE } from '../constants/permissions';

function mapStateToProps(state) {
  return {
    // TODO: use react-router-redux to connect the state and match the pathname for getting the active link (or use react router active link?)
    user: Selectors.getUserModel(state),
    orgReports: Selectors.getOrgReports(state),
    myReports: Selectors.getMyReports(state),
    chatThreads: Selectors.getSortedChatThreads(state),
    showLivePage: false, //Selectors.userHasFeature(SHOW_LIVE_PAGE, state),
    showDemoLivePage: false, //Selectors.userHasFeature(SHOW_DEMO_LIVE_PAGE, state)
    showHeadcountPlanner: Selectors.userHasFeature(
      SHOW_HEADCOUNT_PLANNER,
      state
    ),
    canViewUsers: Selectors.userHasPermission(CAN_VIEW_SETTINGS_PAGE, state),
  };
}

function mapDispatchToProps(dispatch: Dispatch<*>) {
  return bindActionCreators(
    {
      logout: AuthActions.logout,
      updateChatThread: ChatThreadActions.updateChatThread,
      deleteChatThread: ChatThreadActions.deleteChatThread,
      updateDashboardReport: ReportActions.updateDashboardReport,
      deleteDashboardReport: ReportActions.deleteDashboardReport,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
